import { formatMillions } from '../financierFormat';
import {
  StatGrid,
  MetricBox,
  MetricLabel,
  MetricValue,
  MetricNote,
} from './styled';

interface PayrollKpiGridProps {
  totals: {
    net_payout_amount: number;
    gross_accrued_fot: number;
    ndfl_amount: number;
    insurance_contrib_amount: number;
    canteen_deductions: number;
    shifts_worked_mtd: number;
    on_shift_now: number;
    total_attached_workers: number;
  };
}

export function PayrollKpiGrid({ totals }: PayrollKpiGridProps) {
  return (
    <StatGrid>
      <MetricBox>
        <MetricLabel>Чистый ФОТ к выплате</MetricLabel>
        <MetricValue $color="#10b981">{formatMillions(totals.net_payout_amount)}</MetricValue>
        <MetricNote>Начислено «грязными»: {formatMillions(totals.gross_accrued_fot)}</MetricNote>
      </MetricBox>

      <MetricBox>
        <MetricLabel>НДФЛ к перечислению</MetricLabel>
        <MetricValue $color="#8b5cf6">{formatMillions(totals.ndfl_amount)}</MetricValue>
        <MetricNote>ЕНС платёж к 28-му числу</MetricNote>
      </MetricBox>

      <MetricBox>
        <MetricLabel>Страховые взносы (30%)</MetricLabel>
        <MetricValue>{formatMillions(totals.insurance_contrib_amount)}</MetricValue>
        <MetricNote>Пенсионное, мед. и соцстрах</MetricNote>
      </MetricBox>

      <MetricBox>
        <MetricLabel>Удержания за питание</MetricLabel>
        <MetricValue $color="#f59e0b">−{formatMillions(totals.canteen_deductions)}</MetricValue>
        <MetricNote>Сверка с модулем столовых</MetricNote>
      </MetricBox>

      <MetricBox>
        <MetricLabel>Смены MTD / На смене</MetricLabel>
        <MetricValue>{totals.shifts_worked_mtd} смен</MetricValue>
        <MetricNote>
          Сейчас на объектах: <b>{totals.on_shift_now}</b> из {totals.total_attached_workers} чел.
        </MetricNote>
      </MetricBox>
    </StatGrid>
  );
}
